<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiCalculatorVariant } from "@mdi/js";
export default {
  name: "MdiCalculatorVariant",
  data() {
    return {
      svgPath: mdiCalculatorVariant,
    };
  },
};
</script>
